import { DetailInfoModel } from "./detail-Info.model";

/**
 * 忘れず注文商品情報
 * 
 */
export class RememberGoodsInfoModel {
  /** 忘れず注文コードID */
  rememberGoodsId: string = <string>'';
  /** アイテムコード */
  itemCode: string = <string>'';
  /** 忘れず注文商品ステータス 
   * 空欄、 1:承認待、2:承認済 */
  rememberGoodsStatus: string = <string>'';
  /** 商品マスタ単価 */
  masterPrice: string = <string>'';
  /** 商品案内用商品名 */
  guideGoodsName: string = <string>'';
  /** 商品案内用規格名 */
  guideStandardName: string = <string>'';
  /** 注文コード */
  orderNum: string = <string>'';
  /** 注文数変更用注文コード */
  orderChangeOrderNum: string = <string>'';
  /** 増量商品 
   * 0: false 1:true */
  increaseGoods: string = <string>'';
  /** 忘れず注文商品カテゴリコード */
  rememberCategoryCode: string = <string>'';
  /** 受注受付開始企画回 */
  orderReceptionStartCatalog: string = <string>'';
  /** 受注受付終了企画回 */
  orderReceptionEndCatalog: string = <string>'';
  /** 配達開始企画回 */
  deliveryStartCatalog: string = <string>'';
  /** 配達終了企画回 */
  deliveryEndCatalog: string = <string>'';
  /** 配達サイクル区分 */
  deliveryCycleDiv: string = <string>'';
  /** 月毎配達回 */
  monthlyDeliveryTimes: string = <string>'';
  /** 商品企画担当区分 */
  goodsCatalogDiv: string = <string>'';
  /** 休止グループコード */
  pauseGroupCode: string = <string>'';
  /** 生協コード */
  coopCodes: string = <string>'';
  /** 価格情報 */
  detailInfoList: DetailInfoModel[] = [];
}